export const formatDuration = (seconds?: number) => {
  if (!seconds && seconds !== 0) {
    return '';
  }
  const min = Math.floor(seconds / 60);
  const sec = seconds % 60;
  return `${min.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
};
